// extracted by mini-css-extract-plugin
export default {"illustration":"Widget__illustration","widgetContainer":"Widget__widgetContainer"};